import SideBySideTextAndAsset from "segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset";
import ProofsSectionComponent from "./components/proofs-section-component";
import BadgesSectionComponent from "./components/badges-section-component";
import { StyledProofAndBadgesEnterpriseComponent } from "./proof-and-badges-enterprise-component.scss";

const ProofAndBadgesEnterpriseComponent = (props) => {
  const { proofsSection, badgesSection, sideBySideAdvancedProps } = props;

  return (
    <StyledProofAndBadgesEnterpriseComponent className="proof-and-badges-enterprise-component">
      <SideBySideTextAndAsset
        replaceTextComponent={ProofsSectionComponent}
        replaceAssetComponent={BadgesSectionComponent}
        replaceTextComponentProps={proofsSection}
        replaceAssetComponentProps={badgesSection}
        {...sideBySideAdvancedProps}
      />
    </StyledProofAndBadgesEnterpriseComponent>
  );
};

export default ProofAndBadgesEnterpriseComponent;
